import React, {useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import {useLocation, useParams} from "react-router-dom";
import {xcService} from "_services/xcService";
import endpoint from "shared/endpoints";

function ResponsesRest(props) {
    const {t} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {query, search} = useLocation();
    const [answers, setAnswers] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentArea, setStudentArea] = useState();
    const year = +new URLSearchParams(search).get('year');

    let { question } = useParams();

    const getPoint = (item) => {
            if (item.assessment.questionType === "RATING" || item.assessment.questionType === "SINGLE"){
                return item.points
            }
            if (item.assessment.questionType === "RATINGOB"){
                return item.yesno === 1 ?  t("yes") + ". " + item.points : t("no")
            }


    }

    useEffect(() => {
        const areaPath = userType === 'STUDENT' ? `/v1/student/area/CEIBA?year=${year}` : `/v1/student/${studentUid}/area/CEIBA?year=${year}`
        xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));


        const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll(question, {query: {year}}) : `/v1/student/${studentUid}/answers/${question}?year=${year}&withResponses=true`;
        xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));

    }, [userType]);


    return (
        <div className={"container dasboard-informes"}>
            <div className={"container-question container-question__end no-gamificado centerResponses"}>
                <div className={"container-question__auto-margin"}>
                    <div className={"question__header"}>
                        <img className={"question__header-icon"} src={`/assets/img/report.png`}/>
                        <h2>{t("tek.endtitleS")}</h2>
                    </div>
                    <div className={"question__content"}>
                        <div className={"question__content-list"}>
                            {answers && answers.map((item, index) => (
                                <div className={"list-item"} key={item.id}>
                                    <div className={"list-item-l"}>
                                        <p>{item.assessment.question.replace('{{vocArea}}', studentArea?.area?.name ?? '')}</p>
                                    </div>
                                    <div className={"list-item-r"}>
                                        <p>{item.assessment.questionType === 'SINGLE' ? item.response?.question : getPoint(item)}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default withTranslation()(ResponsesRest);


